import React from "react";

export const FetchOptionsContext = React.createContext({
  cachePolicy: "no-cache",
  errorHandlers: [],
  headers: {},
  requestHandlers: [],
  responseHandlers: [],
});
